import { animate, style, transition, trigger } from '@angular/animations';

export const tbSlideInOut = trigger('slideInOut', [
    transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-out', style({ transform: 'translateX(0%)' })),
    ]),
    transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)' }))]),
]);

export const tbRouteAnimations = trigger('routeAnimations', [
    transition('* <=> *', [style({ opacity: 0 }), animate('300ms', style({ opacity: 1 }))]),
]);
